(function () {
  'use strict';

  // Enable progressive enhancement class only if Intersection Observer is supported
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('js-reveal');

    var observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay');
          if (delay) {
            el.style.transitionDelay = delay + 'ms';
          }
          // Delay adding the class slightly so initial paint happens first,
          // which forces the CSS transition to play even for elements already in view.
          setTimeout(function() {
            el.classList.add('is-visible');
          }, 350);
          observer.unobserve(el);
        }
      });
    }, observerOptions);

    window.initScrollReveal = function (container) {
      var root = container || document;
      root.querySelectorAll('.reveal-on-scroll').forEach(function (el) {
        revealObserver.observe(el);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { window.initScrollReveal(); });
    } else {
      window.initScrollReveal();
    }
  }
})();
